
import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';
import { LOGIN, REGISTER, LOGOUT } from '../App';
import BEEICON from "./bee-icon-myLoc.png";



class  NavBarBrand extends Component {

    navbarClickLogin = () => {
        const { navbarClick } = this.props;
        navbarClick(LOGIN);
    }

    navbarClickRegister = () => {
        const { navbarClick } = this.props;
        navbarClick(REGISTER);
    }

    navbarClickLogout = () => {
        const { navbarClick } = this.props;



        navbarClick(LOGOUT);
    }


    setLoginLogout = () => {
        const isLoggedIn = localStorage.getItem('token') !== null;
        const firstName = localStorage.getItem('firstName');

        return (
            <div className="d-flex align-items-center gap-2">
                {isLoggedIn ? (
                    <Fragment>
                        <span className="text-light small">
                            {firstName ? `Not ${firstName}? --> ` : 'Signed in'}
                        </span>
                        <Link
                            to="/logout"
                            onClick={this.navbarClickLogout}
                            className="btn btn-outline-light btn-sm me-1"
                        >
                            Logout
                        </Link>
                    </Fragment>
                ) : (
                    <Fragment>
                        <Link
                            to="/login"
                            onClick={this.navbarClickLogin}
                            className="btn btn-outline-light btn-sm me-2"
                        >
                            Login
                        </Link>
                        <Link
                            to="/signup"
                            onClick={this.navbarClickRegister}
                            className="btn btn-light btn-sm"
                        >
                            Signup
                        </Link>
                    </Fragment>
                )}
            </div>
        );
    };

    render() {
        return (
            <nav className="navbar navbar-dark bg-secondary fixed-top shadow-sm px-3">
                <div className="d-flex align-items-center">
                    <img
                        src={BEEICON}
                        alt="apiTask bee"
                        className="navbar-bee-logo me-1"
                    />
                    <span className="navbar-brand mb-0 ml-1 h5">apiTask</span>
                </div>
                <div className="d-flex align-items-center ms-auto gap-2">
                    {this.setLoginLogout()}
                </div>
            </nav>
        )
    }
}
 
    
export default NavBarBrand;
